import { getQueryString } from '@umu/umu-dom';
import { fetchData } from '@umu/umu-fetch';
import { MICRO_PAGE_TEMPLATE, MICRO_PAGE_MODE, MicroPageType } from '@umu/umu-types';

import API from '../../path';

export interface IAddMicroParams {
    page_id?: string;
    title?: string;
    desc?: string;
    setup_json?: string;
    from_page_id?: string;
    access_close_tip?: string;
    template_id?: string;
}
export interface IMicroAddPageRes {
    page_id: number;
    share_url: string;
}
export const defaultAddRes: IMicroAddPageRes = {
    page_id: -1,
    share_url: '',
};
export const getMicroPageQueryParams = (info = {}): Record<string, string> => {
    const eid = getQueryString('eid') || '';
    return !!eid ? { ...info, eid } : info;
};
/*
 * 添加微页面-基本信息
 */
export const onSaveMicroPageBasicInfoSetting = (
    params: IAddMicroParams,
    type?: MicroPageType,
): Promise<IMicroAddPageRes> => {
    const expendParams = getMicroPageQueryParams();
    const api = type === MicroPageType.COPY ? API.COPY_MICRO_PAGE : API.ADD_MICRO_PAGE;
    return fetchData(api, { ...expendParams, ...params }, { silent: true }).then(
        (res: IResponse<IMicroAddPageRes>) => {
            if (res.error_code && res.error_message) {
                return defaultAddRes;
            }
            return res.data ? res.data : defaultAddRes;
        },
        () => {
            return defaultAddRes;
        },
    );
};

/**
 * 获取微页面列表
 */
export const defaultListRes = {
    list: [],
    page_info: {
        current_page: 1,
        list_total_num: 0,
        total_num: 0,
        size: 20,
        total_page_num: 0,
    },
    is_need_tip_first: false,
};
export interface IMicroPageListParams {
    keyword?: string;
    uids?: string;
    mode?: MICRO_PAGE_TEMPLATE;
    page_mode?: MICRO_PAGE_MODE;
    access_permission?: string;
    page?: number;
    size?: number;
}
export interface IMicroItemInfo {
    access_permission: string;
    create_ts: string;
    creator_id: string;
    desc: string;
    template_id?: string;
    enterprise_id: string;
    id: string;
    is_deleted: string;
    profile_url: string;
    share_url: string;
    title: string;
    update_ts: string;
    updator_id: string;
    user_name: string;
    mode: MICRO_PAGE_TEMPLATE;
    access_close_tip: string;
}
export const getMicroPageList = (params: IMicroPageListParams): Promise<IList<IMicroItemInfo>> => {
    return fetchData(API.GET_MICRO_PAGE_LIST, params, { silent: true }).then(
        (res: IResponse<IList<IMicroItemInfo>>) => {
            return res.data ? res.data : defaultListRes;
        },
        () => {
            return defaultListRes;
        },
    );
};
